import { HTMLAttributes } from "react"

const View = (props: HTMLAttributes<HTMLDivElement>)=>{
    return <div 
    {...props}>{props.children}</div>
}

export default View